import { findIndex as _findIndex, find as _find } from 'lodash';

function getReward(index) {
  return index * 10;
}

const state = {
  state: 0 // 0 = "mediaPlaying", 1 = "playScreen"
};

const actions = {
  startRound: ({ commit, rootGetters }) => {
    commit('ACTIVATE_PLAYER', rootGetters.nextPlayerByLowestScore.id, {
      root: true
    });
    commit('SET_CURRENT_QUESTION', 0, { root: true });
    commit('SHOW_PLAYER_TURN_SCREEN', null, { root: true });
  },
  startQuestion: ({ commit, rootGetters }) => {
    commit('END_PLAYER_FIRST_TURN', rootGetters.activePlayer.id, {
      root: true
    });
    commit('SHOW_ROUND_PLAYSCREEN', null, { root: true });
    commit('SHOW_VIDEO_SCREEN');
  },
  startPlaying: ({ commit, dispatch }) => {
    return dispatch('startClockForActivePlayer', null, { root: true }).then(
      () => {
        commit('SHOW_PLAY_SCREEN');
      }
    );
  },
  answerQuestion: ({ commit, getters, dispatch, rootGetters }, keywordId) => {
    const playerId = rootGetters.activePlayer.id;
    const score = getReward(getters.nrOfKeywordsFound + 1);
    commit('REWARD_PLAYER', { playerId, score }, { root: true });
    commit('MARK_KEYWORD_AS_FOUND', { keywordId, playerId }, { root: true });
    if (getters.allKeywordsAreFound) {
      dispatch('stopClock');
    }
  },
  nextQuestion: ({ dispatch, commit, rootGetters }) => {
    if (rootGetters.nextPlayerToStartAQuestion) {
      commit('DISABLE_REVIEW_MODE', null, { root: true });
      commit('RESET_ALL_PLAYERS_TURNS', null, { root: true });
      commit('RESET_FOUND_KEYWORDS', null, { root: true });
      commit('NEXT_QUESTION', null, { root: true });
      commit('ACTIVATE_PLAYER', rootGetters.nextPlayerToStartAQuestion.id, {
        root: true
      });
      commit('SHOW_PLAYER_TURN_SCREEN', null, { root: true });
    } else {
      dispatch('nextRound', null, { root: true });
    }
  },
  stopClock: ({ dispatch, commit, getters, rootGetters }) => {
    commit('STOP_CLOCK', null, { root: true });
    dispatch('endActivePlayerTurn', null, { root: true });
    if (!getters.allKeywordsAreFound && rootGetters.nextPlayerByLowestScore) {
      commit('ACTIVATE_PLAYER', rootGetters.nextPlayerByLowestScore.id, {
        root: true
      });
    } else {
      dispatch('enableReviewMode', null, { root: true });
    }
  }
};

const mutations = {
  SHOW_VIDEO_SCREEN: state => {
    state.state = 0;
  },
  SHOW_PLAY_SCREEN: state => {
    state.state = 1;
  }
};

const getters = {
  questions(state, getters, rootState) {
    return rootState.questionsPerRound[4].questions;
  },
  activeQuestion(state, getters, rootState) {
    return getters.questions[rootState.game.currentQuestion];
  },
  activeKeywords(state, getters, rootState, rootGetters) {
    return getters.activeQuestion.keywords.map((keyword, keywordId) => {
      const foundOrder = _findIndex(
        rootState.game.foundKeywords,
        k => k.keywordId === keywordId
      );
      const foundKeyword = _find(
        rootState.game.foundKeywords,
        k => k.keywordId === keywordId
      );
      const found = foundOrder > -1;
      const score = found ? getReward(foundOrder + 1) : null;
      return {
        id: keywordId,
        name: keyword,
        found,
        foundBy: foundKeyword
          ? rootGetters.players[foundKeyword.playerId].name
          : false,
        score
      };
    });
  },
  nrOfKeywordsFound(state, getters, rootState) {
    return rootState.game.foundKeywords.length;
  },
  allKeywordsAreFound(state, getters, rootState) {
    return (
      rootState.game.foundKeywords.length ===
      getters.activeQuestion.keywords.length
    );
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
